import React from 'react';
import { useTracker } from '@archipro-website/tracker';
import RefundPolicyDialog from './RefundPolicyDialog';

export interface RefundPolicyData {
    Professional: {
        Title: string;
        Link: string;
    };
}

interface RefundPolicyProps {
    data: RefundPolicyData;
}

/** Inline text that opens the return & refunds policy dialog. */
const RefundPolicy = ({ data }: RefundPolicyProps) => {
    const [refundModalOpen, setRefundModalOpen] = React.useState(false);
    const tracker = useTracker();

    const handleOpen = () => {
        tracker.log('ReturnsRefundsClick', {
            url: new URL(window.location.href),
            targetTracker: 'archiproTracker',
        });
        setRefundModalOpen(true);
    };

    return (
        <>
            <div
                className="cursor-pointer text-base leading-normal tracking-[-0.02em] text-[#9B9B9B] hover:underline hover:underline-offset-2"
                role="button"
                tabIndex={0}
                onClick={handleOpen}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleOpen();
                    }
                }}
            >
                Return & Refunds Policy
            </div>
            <RefundPolicyDialog
                open={refundModalOpen}
                close={() => setRefundModalOpen(false)}
                data={data}
            />
        </>
    );
};

export default RefundPolicy;
